import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";

import { environment } from "@env/environment";
import { FundIncludingLatestNavValue } from "@models/fund-including-latest-nav-value.model";
import { map, Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class FundService {
  constructor(private http: HttpClient) {}

  getFundsIncludingLatestNavValue$(): Observable<
    FundIncludingLatestNavValue[]
  > {
    return this.http
      .get<
        FundIncludingLatestNavValue[]
      >(`${environment.BASE_URL}fund/latestnav`)
      .pipe(
        map((data): FundIncludingLatestNavValue[] => {
          return data;
        })
      );
  }
}
